import { UpgradeTransactionState } from 'fourwaves-shared';

export default {
  transaction: {
    back_to_list: 'Back to all transactions',
    complete_payment: 'Complete Payment',
    download_receipt: 'Download',
    subtotal: 'Subtotal',
    total: 'Total',
    powered_by: 'Guaranteed safe & secure checkout',
    vat_number: 'VAT number',
    invoice_number: 'Invoice Number',
    taxes: {
      gst: 'GST',
      hst: 'HST',
      qst: 'QST',
      vat: 'VAT',
      pst: 'PST',
    },
    invoice: {
      title: 'Invoice',
      event: 'Event',
      transaction_date: 'Transaction Date',
      purchase_date: 'Invoice Date',
      due_date: 'Due Date',
      payment_due: 'Payment due before {date}.',
      payment_method: 'Payment Method',
      purchased_by: 'Purchased By',
      invoiced_to: 'Invoiced To',
      billing_address: 'Billing Address',
      payment_instructions: 'Payment Instructions',
      seller_details: 'Seller details and terms',
      fw_statement_descriptor: 'Your credit card statement will show a charge from FOURWAVES EVENTS.',
      due_by: 'Due by {date}',
      overdue: 'Overdue',
      vat_user: 'VAT: {vat}',
      vat0: 'VAT 0%',
      vatreversecharge0: 'VAT reverse charge 0%',
      po_number: 'PO Number',
    },
    table: {
      title: 'Transactions',
      transaction_id: 'Transaction ID',
      payment_gateway_id: 'ID - Payment',
      creation_date: 'Creation Date',
      invoice_date: 'Invoice Date',
      due_date: 'Due Date',
      company: 'Company',
      card_name: 'Name on card',
      invoiced_to: 'Invoiced To',
      full_name: 'Name / Company',
      card_type: 'Card type',
      card_last4digits: 'Last 4',
      card: 'Card',
      ending_in: 'ending in',
      items: 'Item Count',
      coupon_code: 'Coupon Code',
      for: 'For',
      by: 'By',
      payment_method: 'Payment method',
      type: 'Transaction type',
      fourwaves_fee: 'Fourwaves fee',
      stripe_fee: 'Stripe fee',
      profit: 'Profit',
      payment_gateway_fee: 'Payment gateway fee',
      full_address: 'Billing address',
      currency: 'Currency',
      event_name: 'Event Name',
      status: 'Status',
    },
    payment_methods: {
      stripe: 'Credit Card (Stripe)',
      paysafe: 'Credit Card (Paysafe)',
      touchnet: 'Credit Card (TouchNet)',
      alipay: 'Credit Card (Alipay)',
      publisoft: 'Credit Card (Publisoft)',
      globalpayments: 'Credit Card (Global Payments)',
      moneris: 'Credit Card (Moneris)',
      bypass: 'Ignored',
      invoicing: 'Invoicing',
      void: 'Ignored',
      paypal: 'PayPal',
      forwardpayment: 'Transaction Pending',
      creditcard: 'Credit Card',
    },
    refund_modal: {
      title: 'Refund charge',
      paid: 'Paid',
      refunded: 'Refunded',
      refundable: 'Refundable',
      fully_refunded: 'The total amount paid was fully refunded.',
      unsupported: 'It is not possible to refund this type of transaction.',
      amount: 'Enter amount to refund',
    },
    update_modal: {
      title_pending: 'Mark as Paid',
      title_concluded: 'Mark as Unpaid',
      message_pending:
        'Would you like to mark this transaction as paid? An email will be sent to notify the participant.',
      message_concluded: 'Would you like to mark this transaction as unpaid?',
    },
    remove_modal: {
      title: 'Remove a transaction',
      content: 'Do you really want to delete this transaction? This action is permanent and cannot be undone.',
    },
    status: {
      pending: 'Unpaid',
      concluded: 'Paid',
      canceled: 'Declined',
      forward_payment: 'Payment Missing',
    },
    state: {
      [UpgradeTransactionState.PaymentPending]: 'Payment Pending',
      [UpgradeTransactionState.PaymentMissing]: 'Payment Missing',
      [UpgradeTransactionState.Overdue]: 'Overdue',
      [UpgradeTransactionState.Canceled]: 'Canceled',
      [UpgradeTransactionState.Paid]: 'Paid',
    },
  },
};
